import { useState, useEffect } from 'react';
import NavbarBase from './NavbarBase';
import SidebarBase from './SidebarBase';
import { UserRole } from '../../types/UserRole';

interface LayoutBaseProps {
  children: React.ReactNode;
  role: UserRole;
}

export default function LayoutBase({ children, role }: LayoutBaseProps) {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkDesktop = () => setIsDesktop(window.matchMedia('(min-width: 1024px)').matches);
    checkDesktop();
    window.addEventListener('resize', checkDesktop);
    return () => window.removeEventListener('resize', checkDesktop);
  }, []);

  return (
    <div className="min-h-screen bg-slate-200 bg-[radial-gradient(ellipse_85%_55%_at_50%_-5%,rgba(37,99,235,0.24),transparent_55%),radial-gradient(ellipse_60%_40%_at_100%_0%,rgba(30,64,175,0.12),transparent_60%),linear-gradient(180deg,rgba(15,23,42,0.04),rgba(15,23,42,0))]">
      {!isDesktop && isMobileSidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-slate-950/55 backdrop-blur-[2px] lg:hidden"
          onClick={() => setIsMobileSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <SidebarBase
        isOpen={isDesktop || isMobileSidebarOpen}
        onCloseMobile={() => setIsMobileSidebarOpen(false)}
        role={role}
      />

      <div className="lg:ml-64 flex min-h-screen flex-col">
        <NavbarBase
          toggleSidebar={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)}
          isSidebarOpen={isMobileSidebarOpen}
          role={role}
        />

        <main className="flex-1 pt-16">
          <div className="mx-auto w-full max-w-[1600px] px-4 py-6 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
